import { useState, useEffect, useCallback } from "react";

import { getScroll } from "~/components/videoProductPage/utils/getScroll";

export const useIsSidebarSticky = () => {
  const [isSidebarSticky, setIsSidebarSticky] = useState<boolean>(true);

  const checkScrollTop = useCallback((event: Event) => {
    const offsetFromTop = getScroll(event.target as HTMLElement);

    if (offsetFromTop > 69) {
      setIsSidebarSticky(true);
    } else {
      setIsSidebarSticky(false);
    }
  }, []);

  useEffect(() => {
    window.addEventListener("scroll", checkScrollTop);
  }, [checkScrollTop]);

  return isSidebarSticky;
};
